import moment from 'moment';
import React, { useEffect } from 'react';
import { ProductPriceInfo } from 'Components/widgets/product-price-info/ProductPriceInfo';
import { t } from 'Src/i18n';
export const DayPriceDetails = ({
  day,
  duration,
  departureCity,
  hasTransport,
  isJoyview,
  isVisible,
  setIsVisible,
  shouldDisplayDetails,
  unit,
}: {
  day: Date;
  duration: number;
  departureCity: string;
  hasTransport: boolean;
  isJoyview?: boolean;
  isVisible: boolean;
  setIsVisible: (arg0: boolean) => void;
  shouldDisplayDetails: boolean;
  unit: string;
}) => {
  useEffect(() => {
    setIsVisible(shouldDisplayDetails);
  }, [shouldDisplayDetails]);
  const dateFormat = t('resort.startingPrice.dateFormat');
  const startDate = moment(day).format(dateFormat);
  const endDate = moment(day)
    .add({
      days: duration,
    })
    .format(dateFormat);
  return (
    isVisible &&
    shouldDisplayDetails && (
      <div className="text-initial absolute left-1/2 top-0 z-2 w-400 -translate-x-1/2 transform font-normal">
        <div className="animation-duration-500 absolute inset-x-0 bottom-full animate-fadeIn">
          <div className="arrow-down arrow-large arrow-white rounded-12 bg-white shadow-md after:drop-shadow-md">
            <ProductPriceInfo
              city={departureCity}
              endDate={endDate}
              hasTransport={hasTransport}
              isJoyview={isJoyview}
              startDate={startDate}
              unit={unit}
            />
          </div>
        </div>
      </div>
    )
  );
};
